/* MOJ Scent Finder: runs the QR flow (gender > scent types > matches) and the brand path.
   Product JSON is printed by the section; pages past 250 products are fetched via the
   Section Rendering API so the whole catalog is searchable. */
(function () {
  'use strict';

  // Escape keyword text before building a regex so characters like "+" or "." can't break matching.
  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  // Comma-separated block keywords become word-boundary regexes, so "oud" matches "Oud" but not "cloud".
  function toPatterns(csv) {
    return csv.split(',')
      .map(function (k) { return k.trim().toLowerCase(); })
      .filter(Boolean)
      .map(function (k) { return new RegExp('\\b' + escapeRe(k) + '\\b', 'i'); });
  }

  // "Aventus by Creed" -> "Creed". Uses the last " by " so product names containing "by" still work.
  function houseOf(inspired) {
    if (!inspired) return null;
    var i = inspired.toLowerCase().lastIndexOf(' by ');
    return i === -1 ? null : inspired.slice(i + 4).trim();
  }

  // Fetch product JSON pages 2..n through the Section Rendering API.
  function loadRest(pages, sectionId) {
    var jobs = [];
    for (var p = 2; p <= pages; p++) {
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&page=' + p;
      jobs.push(fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var node = new DOMParser().parseFromString(html, 'text/html').querySelector('.moj-finder__data');
          return node ? JSON.parse(node.textContent) : [];
        })
        // One failed page must not break the finder; shoppers still get results from what loaded.
        .catch(function () { return []; }));
    }
    return Promise.all(jobs).then(function (lists) { return [].concat.apply([], lists); });
  }

  function init(root) {
    var d = root.dataset;
    var dataNode = root.querySelector('.moj-finder__data');
    var products = JSON.parse(dataNode.textContent);
    // Every action waits on this promise, so results are always complete even on slow mobile data.
    var ready = loadRest(parseInt(dataNode.dataset.pages, 10) || 1, d.sectionId)
      .then(function (more) { products = products.concat(more); return products; });

    var gender = null;
    var chips = Array.prototype.slice.call(root.querySelectorAll('.moj-finder__chip'));
    var cta = root.querySelector('[data-action="show"]');
    var grid = root.querySelector('.moj-finder__grid');
    var resultsTitle = root.querySelector('.moj-finder__results-title');
    var count = root.querySelector('.moj-finder__count');
    var brandList = root.querySelector('.moj-finder__brands');
    var search = root.querySelector('.moj-finder__search');

    // Show one screen at a time; move focus to its heading so screen-reader users follow the steps.
    function show(name) {
      root.querySelectorAll('[data-screen]').forEach(function (s) { s.hidden = s.dataset.screen !== name; });
      var h = root.querySelector('[data-screen="' + name + '"] .moj-finder__title');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      root.scrollIntoView({ block: 'start' });
    }

    // Build a product card with textContent only, so catalog text can never inject markup.
    function card(p) {
      var li = document.createElement('li');
      li.className = 'moj-finder__card';
      var a = document.createElement('a');
      a.className = 'moj-finder__card-link';
      a.href = p.u;
      if (p.i) {
        var img = document.createElement('img');
        img.className = 'moj-finder__card-img';
        img.src = p.i; img.alt = p.t; img.loading = 'lazy'; img.width = 400; img.height = 400;
        a.appendChild(img);
      }
      [
        ['moj-finder__card-title', p.t],
        ['moj-finder__card-meta', p.b ? d.labelInspired + ' ' + p.b : ''],
        ['moj-finder__card-meta', p.g],
        ['moj-finder__card-price', p.p]
      ].forEach(function (row) {
        if (!row[1]) return;
        var s = document.createElement('span');
        s.className = row[0];
        s.textContent = row[1];
        a.appendChild(s);
      });
      li.appendChild(a);
      return li;
    }

    function renderResults(title, list) {
      resultsTitle.textContent = title;
      count.textContent = list.length ? list.length + ' ' + d.labelMatches : d.labelNone;
      grid.innerHTML = '';
      list.forEach(function (p) { grid.appendChild(card(p)); });
      show('results');
    }

    // Step 1: remember the gender, go to scent types.
    root.querySelectorAll('[data-gender]').forEach(function (btn) {
      btn.addEventListener('click', function () { gender = btn.dataset.gender.toLowerCase(); show('type'); });
    });

    // Step 2: chips toggle; the results button unlocks once at least one is picked.
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        cta.disabled = !chips.some(function (c) { return c.getAttribute('aria-pressed') === 'true'; });
      });
    });

    // Scoring: per picked type, +2 if it matches the scent family, +1 if only a note matches.
    // Highest score first, then in-stock before sold out.
    cta.addEventListener('click', function () {
      var picked = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; });
      var sets = picked.map(function (c) { return toPatterns(c.dataset.keywords); });
      ready.then(function (all) {
        var list = all.filter(function (p) {
          var g = (p.g || '').toLowerCase();
          return g === gender || (d.includeUnisex === 'true' && g === 'unisex');
        }).map(function (p) {
          var score = 0;
          sets.forEach(function (pats) {
            if (pats.some(function (re) { return re.test(p.f || ''); })) score += 2;
            else if (pats.some(function (re) { return re.test(p.n || ''); })) score += 1;
          });
          return { p: p, s: score };
        }).filter(function (x) { return x.s > 0; })
          .sort(function (a, b) { return (b.s - a.s) || (Number(b.p.a) - Number(a.p.a)); })
          .map(function (x) { return x.p; });
        renderResults(picked.map(function (c) { return c.textContent.trim(); }).join(' · '), list);
      });
    });

    // Brand path: group by house, A to Z, with a live search filter.
    function renderBrands(filter) {
      ready.then(function (all) {
        var map = {};
        all.forEach(function (p) {
          var h = houseOf(p.b);
          if (h) (map[h] = map[h] || []).push(p);
        });
        var q = (filter || '').trim().toLowerCase();
        brandList.innerHTML = '';
        Object.keys(map)
          .sort(function (a, b) { return a.localeCompare(b); })
          .filter(function (h) { return !q || h.toLowerCase().indexOf(q) !== -1; })
          .forEach(function (h) {
            var li = document.createElement('li');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'moj-finder__brand';
            var name = document.createElement('span');
            name.textContent = h;
            var n = document.createElement('span');
            n.className = 'moj-finder__brand-count';
            n.textContent = map[h].length;
            btn.append(name, n);
            btn.addEventListener('click', function () { renderResults(h, map[h]); });
            li.appendChild(btn);
            brandList.appendChild(li);
          });
      });
    }
    search.addEventListener('input', function () { renderBrands(search.value); });

    // Back, brand link and start over all route through data-go.
    root.querySelectorAll('[data-go]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var to = btn.dataset.go;
        if (to === 'restart') {
          // Clear previous picks so the next shopper starts fresh.
          chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          cta.disabled = true;
          gender = null;
          to = 'gender';
        }
        if (to === 'brand') renderBrands(search.value);
        show(to);
      });
    });
  }

  document.querySelectorAll('.moj-finder').forEach(init);
})();